// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner
// } from "react-bootstrap";
// import { Search, Grid3x3, List } from "react-bootstrap-icons";
// import CreateGroupForm from "../Components/GroupPageSection/CreateGroupForm";
// import Header from "../Components/Header";
// import Swal from "sweetalert2";
// // import CreateGroupPage2 from "./CreateGroupPage2";

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState("all");
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortBy, setSortBy] = useState("Most Members");
//   const [groups, setGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get("https://tdtlworld.com/dss-kaas-backend/socialapp/groups/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data;

//         // Sort groups by most members FIRST
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));

//         setGroups(fetchedGroups);
//       })
//       .catch((error) => {
//         console.error("Error fetching groups:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [token]); // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups];

//     if (sortBy === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//     } else if (sortBy === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//     } else if (sortBy === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     setGroups(sortedGroups);
//   }, [sortBy]); // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

// //   const handleGroupClick = () => {
// //     navigate('/create-group-page2');
// // };

// // const handleJoinGroup = (groupId) => {
// //   axios.post(
// //     `https://tdtlworld.com/dss-kaas-backend/socialapp/groups/${groupId}/join/`,
// //     {},
// //     { headers: { Authorization: `Bearer ${token}` } }
// //   )
// //   .then(() => {
// //     console.log("Joined group successfully!");
// //   })
// //   .catch((error) => {
// //     console.error("Error joining group:", error);
// //   });
// // };
// const [pendingJoinRequests, setPendingJoinRequests] = useState([]);

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `https://tdtlworld.com/dss-kaas-backend/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId
//               ? { ...group, is_pending: true }
//               : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           });
//         }
//         console.error("Error joining group:", error);
//       });
//   };

// const backendURL = "https://kaasbackend.vetrinahealthcare.com";

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split("/db-shiksha/kaas/")
//                   .pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="w-100"
//           style={{ height: "220px", objectFit: "cover", borderRadius: "20px" }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background:
//               "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"}{" "}
//             {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p
//           className="text-muted text-truncate"
//           style={{ minHeight: "50px", fontSize: "14px" }}
//         >
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span
//             className="text-muted fw-semibold"
//             style={{ color: "#B8529E", fontSize: "1.2rem" }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {/* <Button
//             variant="primary"
//             size="sm"
//             className="rounded-pill px-4 shadow-sm"
//             style={{
//               background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",

//               border: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleJoinGroup(group.id);
//             }}
//           >
//             Join
//           </Button> */}
//             <Button
//       variant={
//         group.is_connected
//           ? "secondary"
//           : group.is_pending
//           ? "warning"
//           : "primary"
//       }
//       size="sm"
//       className="rounded-pill px-4 shadow-sm"
//       style={{
//         background: group.is_connected
//           ? "gray"
//           : group.is_pending
//           ? "orange"
//           : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//         border: "none",
//       }}
//       disabled={group.is_connected || group.is_pending}
//       onClick={(e) => {
//         e.stopPropagation();
//         handleJoinGroup(group.id, group.is_connected);
//       }}
//     >
//       {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//     </Button>

//         </div>
//       </Card.Body>
//     </Card>
//   );

//   if (activeTab === "create") {
//     return <CreateGroupForm />;
//   }

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control placeholder="Search Groups..." className="border-start-0" style={{ boxShadow: "none" }} />
//           </InputGroup>
//         </div>
//         <Nav className="mb-4">
//   {["all", "my", "create"].map((tab) => (
//     <Nav.Item key={tab}>
//       <Nav.Link
//         onClick={() => setActiveTab(tab)}
//         style={{
//           backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//           color: activeTab === tab ? "white" : "#6c757d",
//           borderRadius: "50px",
//           padding: "8px 16px",
//           transition: "background-color 0.3s ease",
//         }}
//       >
//         {tab === "all" ? "All Groups" : tab === "my" ? "My Groups" : "Create a Group"}
//       </Nav.Link>
//     </Nav.Item>
//   ))}
// </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {groups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//   <Button
//     style={{
//       backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "grid" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("grid")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <Grid3x3 />
//   </Button>

//   <Button
//     style={{
//       backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "list" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("list")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <List />
//   </Button>
// </div>

//           </div>
//         </div>
//         {loading ? ( // ⬅️ Show spinner while loading
//           <div className="text-center my-5">
//             <Spinner animation="border" variant="primary" />
//             <p className="mt-2">Loading groups...</p>
//           </div>
//         ) : (
//         <Row>
//           {groups.length > 0 ? (
//             groups.map((group) => (
//               <Col md={6} lg={4} className="mb-4" key={group.id}>
//                 {renderGroupCard(group)}
//               </Col>
//             ))
//           ) : (
//             <p className="text-center text-muted">No groups found.</p>
//           )}

//         </Row>
//            )}
//       </Container>
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner
// } from "react-bootstrap";
// import { Search, Grid3x3, List } from "react-bootstrap-icons";
// import CreateGroupForm from "../Components/GroupPageSection/CreateGroupForm";
// import Header from "../Components/Header";
// import Swal from "sweetalert2";
// // import CreateGroupPage2 from "./CreateGroupPage2";

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState("all");
//   const [viewMode, setViewMode] = useState("grid");
//   const [sortBy, setSortBy] = useState("Most Members");
//   const [groups, setGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();
//   const token = localStorage.getItem("jwttoken");

//   useEffect(() => {
//     setLoading(true);
//     axios
//       .get("https://tdtlworld.com/dss-kaas-backend/socialapp/groups/", {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data;

//         // Sort groups by most members FIRST
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));

//         setGroups(fetchedGroups);
//       })
//       .catch((error) => {
//         console.error("Error fetching groups:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [token]); // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups];

//     if (sortBy === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//     } else if (sortBy === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//     } else if (sortBy === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     setGroups(sortedGroups);
//   }, [sortBy]); // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

// //   const handleGroupClick = () => {
// //     navigate('/create-group-page2');
// // };

// // const handleJoinGroup = (groupId) => {
// //   axios.post(
// //     `https://tdtlworld.com/dss-kaas-backend/socialapp/groups/${groupId}/join/`,
// //     {},
// //     { headers: { Authorization: `Bearer ${token}` } }
// //   )
// //   .then(() => {
// //     console.log("Joined group successfully!");
// //   })
// //   .catch((error) => {
// //     console.error("Error joining group:", error);
// //   });
// // };
// const [pendingJoinRequests, setPendingJoinRequests] = useState([]);

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `https://tdtlworld.com/dss-kaas-backend/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId
//               ? { ...group, is_pending: true }
//               : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           });
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           });
//         }
//         console.error("Error joining group:", error);
//       });
//   };

// const backendURL = "https://kaasbackend.vetrinahealthcare.com";

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split("/db-shiksha/kaas/")
//                   .pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="w-100"
//           style={{ height: "220px", objectFit: "cover", borderRadius: "20px" }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background:
//               "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"}{" "}
//             {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p
//           className="text-muted text-truncate"
//           style={{ minHeight: "50px", fontSize: "14px" }}
//         >
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span
//             className="text-muted fw-semibold"
//             style={{ color: "#B8529E", fontSize: "1.2rem" }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {/* <Button
//             variant="primary"
//             size="sm"
//             className="rounded-pill px-4 shadow-sm"
//             style={{
//               background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",

//               border: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               handleJoinGroup(group.id);
//             }}
//           >
//             Join
//           </Button> */}
//             <Button
//       variant={
//         group.is_connected
//           ? "secondary"
//           : group.is_pending
//           ? "warning"
//           : "primary"
//       }
//       size="sm"
//       className="rounded-pill px-4 shadow-sm"
//       style={{
//         background: group.is_connected
//           ? "gray"
//           : group.is_pending
//           ? "orange"
//           : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//         border: "none",
//       }}
//       disabled={group.is_connected || group.is_pending}
//       onClick={(e) => {
//         e.stopPropagation();
//         handleJoinGroup(group.id, group.is_connected);
//       }}
//     >
//       {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//     </Button>

//         </div>
//       </Card.Body>
//     </Card>
//   );

//   // if (activeTab === "create") {
//   //   return <CreateGroupForm />;
//   // }

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control placeholder="Search Groups..." className="border-start-0" style={{ boxShadow: "none" }} />
//           </InputGroup>
//         </div>
//         <Nav className="mb-4">
//   {["all", "my" /*, "create" */].map((tab) => (
//     <Nav.Item key={tab}>
//       <Nav.Link
//         onClick={() => setActiveTab(tab)}
//         style={{
//           backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//           color: activeTab === tab ? "white" : "#6c757d",
//           borderRadius: "50px",
//           padding: "8px 16px",
//           transition: "background-color 0.3s ease",
//         }}
//       >
//         {tab === "all" ? "All Groups" : tab === "my" ? "My Groups": "" /*: "Create a Group"*/}
//       </Nav.Link>
//     </Nav.Item>
//   ))}
// </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {groups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//   <Button
//     style={{
//       backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "grid" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("grid")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <Grid3x3 />
//   </Button>

//   <Button
//     style={{
//       backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//       borderColor: "#B8529E",
//       color: viewMode === "list" ? "white" : "#B8529E",
//     }}
//     onClick={() => setViewMode("list")}
//     className="d-flex align-items-center justify-content-center"
//   >
//     <List />
//   </Button>
// </div>

//           </div>
//         </div>
//         {loading ? ( // ⬅️ Show spinner while loading
//           <div className="text-center my-5">
//             <Spinner animation="border" variant="primary" />
//             <p className="mt-2">Loading groups...</p>
//           </div>
//         ) : (
//         <Row>
//           {groups.length > 0 ? (
//             groups.map((group) => (
//               <Col md={6} lg={4} className="mb-4" key={group.id}>
//                 {renderGroupCard(group)}
//               </Col>
//             ))
//           ) : (
//             <p className="text-center text-muted">No groups found.</p>
//           )}

//         </Row>
//            )}
//       </Container>
//     </>
//   );
// }

// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import { useNavigate } from 'react-router-dom'
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner,
// } from 'react-bootstrap'
// import { Search, Grid3x3, List } from 'react-bootstrap-icons'
// import CreateGroupForm from '../Components/GroupPageSection/CreateGroupForm'
// import Header from '../Components/Header'
// import Swal from 'sweetalert2'
// import CreateGroupPage2 from './CreateGroupPage2'

// export default function GroupsPage2() {
//   const [activeTab, setActiveTab] = useState('all')
//   const [viewMode, setViewMode] = useState('grid')
//   const [sortBy, setSortBy] = useState('Most Members')
//   const [groups, setGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const navigate = useNavigate()
//   const token = localStorage.getItem('jwttoken')

//   useEffect(() => {
//     setLoading(true)
//     axios
//       .get('https://tdtlworld.com/dss-kaas-backend/socialapp/groups/', {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         let fetchedGroups = response.data

//         // Sort groups by most members FIRST
//         fetchedGroups.sort(
//           (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//         )

//         setGroups(fetchedGroups)
//       })
//       .catch((error) => {
//         console.error('Error fetching groups:', error)
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }, [token]) // Runs only when token changes

//   useEffect(() => {
//     let sortedGroups = [...groups]

//     if (sortBy === 'Recently Active') {
//       sortedGroups.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       )
//     } else if (sortBy === 'Most Members') {
//       sortedGroups.sort(
//         (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//       )
//     } else if (sortBy === 'Alphabetical') {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     setGroups(sortedGroups)
//   }, [sortBy]) // Sorts when the user changes sorting

//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`)
//   }

//   const handleCreateGroupClick = () => {
//     navigate('/create-group-page2')
//   }

//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])

//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: 'info',
//         title: "You're already a member!",
//         text: 'You have already joined this group.',
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(
//         `https://tdtlworld.com/dss-kaas-backend/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: 'success',
//           title: 'Join Request Submitted!',
//           text: 'Your request has been sent. Waiting for approval.',
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId ? { ...group, is_pending: true } : group
//           )
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: 'info',
//             title: "You're already a member!",
//             text: 'You have already joined this group.',
//           })
//         } else {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Something went wrong while joining the group.',
//           })
//         }
//         console.error('Error joining group:', error)
//       })
//   }

//   const backendURL = 'https://kaasbackend.vetrinahealthcare.com'

//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className='h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform'
//       style={{
//         background: '#fff',
//         borderRadius: '20px',
//         transition: 'transform 0.3s ease-in-out',
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className='position-relative'>
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split('/')
//                   .pop()}`
//               : 'https://placehold.co/400x200?text=Group+Cover&font=roboto' // Default placeholder
//           }
//           alt='Group Cover'
//           className='w-100'
//           style={{ height: '220px', objectFit: 'cover', borderRadius: '20px' }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className='position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white'
//           style={{
//             fontSize: '12px',
//             background: 'rgba(0, 0, 0, 0.6)',
//             backdropFilter: 'blur(5px)',
//             textTransform: 'uppercase',
//           }}
//         >
//           {group.privacy === 'public' ? '🌍 Public' : '🔒 Private'}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className='position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white'
//           style={{
//             background:
//               'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
//           }}
//         >
//           <h3
//             className='h5 fw-bold mb-1 text-truncate'
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: 'pointer', maxWidth: '90%' }}
//           >
//             {group.name || 'Unnamed Group'}
//           </h3>
//           <p className='small mb-0'>
//             Created by {group.created_by?.first_name || 'Unknown'}{' '}
//             {group.created_by?.last_name || ''}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className='p-4'>
//         <p
//           className='text-muted text-truncate'
//           style={{ minHeight: '50px', fontSize: '14px' }}
//         >
//           {group.description || 'No description available.'}
//         </p>

//         {/* Members & Join Button */}
//         <div className='d-flex justify-content-between align-items-center'>
//           <span
//             className='text-muted fw-semibold'
//             style={{ color: '#B8529E', fontSize: '1.2rem' }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           <Button
//             variant={
//               group.is_connected
//                 ? 'secondary'
//                 : group.is_pending
//                 ? 'warning'
//                 : 'primary'
//             }
//             size='sm'
//             className='rounded-pill px-4 shadow-sm'
//             style={{
//               background: group.is_connected
//                 ? 'gray'
//                 : group.is_pending
//                 ? 'orange'
//                 : 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//               border: 'none',
//             }}
//             disabled={group.is_connected || group.is_pending}
//             onClick={(e) => {
//               e.stopPropagation()
//               handleJoinGroup(group.id, group.is_connected)
//             }}
//           >
//             {group.is_connected
//               ? 'Joined'
//               : group.is_pending
//               ? 'Pending'
//               : 'Join'}
//           </Button>
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   if (activeTab === 'create') {
//     return <CreateGroupPage2 />
//   }

//   return (
//     <>
//       <Header />
//       <Container className='py-4' >
//       <div className='d-flex justify-content-between align-items-center mb-4' style={{ marginTop: '3.5rem' }}>
//                 <h1 className='fw-bold'>Groups</h1>
//           <InputGroup style={{ width: '300px' }}>
//             <InputGroup.Text className='bg-white border-end-0'>
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder='Search Groups...'
//               className='border-start-0'
//               style={{ boxShadow: 'none' }}
//             />
//           </InputGroup>
//         </div>
//         <Nav className='mb-4'>
//           {['all', 'my','create'].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor:
//                     activeTab === tab ? '#B8529E' : 'transparent',
//                   color: activeTab === tab ? 'white' : '#6c757d',
//                   borderRadius: '50px',
//                   padding: '8px 16px',
//                   transition: 'background-color 0.3s ease',
//                 }}
//               >
// {tab === 'all'
//   ? 'All Groups'
//   : tab === 'my'
//   ? 'My Groups'
//   : tab === 'create'
//   ? 'Create a Group'
//   : ''}
//                 {/* {{
//                   all: 'All Groups',
//                   my: 'My Groups',
//                 }[tab] || ''} */}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//         </Nav>

//         <div className='d-flex justify-content-between align-items-center mb-4'>
//           <p className='text-muted mb-0'>Showing {groups.length} groups</p>
//           <div className='d-flex gap-2'>
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant='outline-secondary'
//                 className='d-flex align-items-center gap-2'
//               >
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {['Recently Active', 'Most Members', 'Alphabetical'].map(
//                   (option) => (
//                     <Dropdown.Item
//                       key={option}
//                       onClick={() => setSortBy(option)}
//                     >
//                       {option}
//                     </Dropdown.Item>
//                   )
//                 )}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className='btn-group'>
//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'grid' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'grid' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('grid')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'list' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'list' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('list')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>
//         {loading ? (
//           <div className='text-center my-5'>
//             <Spinner animation='border' variant='primary' />
//             <p className='mt-2'>Loading groups...</p>
//           </div>
//         ) : (
//           <Row>
//             {groups.length > 0 ? (
//               groups.map((group) => (
//                 <Col md={6} lg={4} className='mb-4' key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className='col-12 text-center py-5'>
//                 <img
//                   src='https://cdn-icons-png.flaticon.com/512/4076/4076478.png'
//                   alt='No groups'
//                   style={{ width: '150px', opacity: 0.7, marginBottom: '20px' }}
//                 />
//                 <h4 className='text-muted'>No groups found</h4>
//                 <p className='text-muted mb-4'>
//                   Be the first to create a group!
//                 </p>
//                 <Button
//                   variant='primary'
//                   onClick={handleCreateGroupClick}
//                   style={{
//                     background:
//                       'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                     border: 'none',
//                     padding: '10px 25px',
//                     borderRadius: '25px',
//                     fontWeight: '500',
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>
//     </>
//   )
// }
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import {
//   Container,
//   InputGroup,
//   Form,
//   Button,
//   Card,
//   Nav,
//   Row,
//   Col,
//   Dropdown,
//   Spinner,
//   Modal
// } from 'react-bootstrap';
// import CreateGroupPage2 from './CreateGroupPage2'
// import { Search, Grid3x3, List } from 'react-bootstrap-icons';
// import Swal from 'sweetalert2';
// import Header from '../Components/Header'
// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState('all');
//   const [viewMode, setViewMode] = useState('grid');
//   const [sortBy, setSortBy] = useState('Most Members');
//   const [groups, setGroups] = useState([]);
//   const [myGroups, setMyGroups] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([]);

//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: '',
//     description: '',
//     privacy: 'public',
//     is_active: true,
//     post_permission: 'admin_only',
//     invite_permission: 'user'
//   });

//   const navigate = useNavigate();
//   const token = localStorage.getItem('jwttoken');
//   const backendURL = 'https://kaasbackend.vetrinahealthcare.com';

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === 'all') {
//       setLoading(true);
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           let fetchedGroups = response.data;
//           // Sort groups by most members first
//           fetchedGroups.sort(
//             (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//           );
//           setGroups(fetchedGroups);
//         })
//         .catch((error) => {
//           console.error('Error fetching groups:', error);
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Failed to load groups. Please try again later.',
//           });
//         })
//         .finally(() => {
//           setLoading(false);
//         });
//     }
//   }, [token, activeTab]);

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === 'my') {
//       setLoading(true);
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data;

//           // Get the group details for each membership
//           const groupPromises = memberships.map(membership =>
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             })
//           );

//           Promise.all(groupPromises)
//             .then(groupResponses => {
//               const myGroupsData = groupResponses.map(res => ({
//                 ...res.data,
//                 is_connected: true // Mark as already joined
//               }));

//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy);
//               setMyGroups(myGroupsData);
//             })
//             .catch(error => {
//               console.error('Error fetching group details:', error);
//             })
//             .finally(() => {
//               setLoading(false);
//             });
//         })
//         .catch((error) => {
//           console.error('Error fetching group memberships:', error);
//           setLoading(false);
//         });
//     }
//   }, [token, activeTab]);

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === 'all') {
//       sortGroups([...groups], sortBy);
//     } else if (activeTab === 'my') {
//       sortGroups([...myGroups], sortBy);
//     }
//   }, [sortBy]);

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     let sortedGroups = [...groupsToSort];

//     if (criteria === 'Recently Active') {
//       sortedGroups.sort(
//         (a, b) => new Date(b.created_at) - new Date(a.created_at)
//       );
//     } else if (criteria === 'Most Members') {
//       sortedGroups.sort(
//         (a, b) => (b.members?.length || 0) - (a.members?.length || 0)
//       );
//     } else if (criteria === 'Alphabetical') {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     if (activeTab === 'all') {
//       setGroups(sortedGroups);
//     } else if (activeTab === 'my') {
//       setMyGroups(sortedGroups);
//     }
//   };

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`);
//   };

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: 'info',
//         title: "You're already a member!",
//         text: 'You have already joined this group.',
//       });
//       return;
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]); // Set to pending

//     axios
//       .post(
//         `${backendURL}/socialapp/groups/${groupId}/join/`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       )
//       .then(() => {
//         Swal.fire({
//           icon: 'success',
//           title: 'Join Request Submitted!',
//           text: 'Your request has been sent. Waiting for approval.',
//         });

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) =>
//             group.id === groupId ? { ...group, is_pending: true } : group
//           )
//         );
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)); // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: 'info',
//             title: "You're already a member!",
//             text: 'You have already joined this group.',
//           });
//         } else {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Something went wrong while joining the group.',
//           });
//         }
//         console.error('Error joining group:', error);
//       });
//   };

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup({
//       ...newGroup,
//       [name]: value
//     });
//   };

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup({
//       ...newGroup,
//       [name]: value
//     });
//   };

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault();
//     setLoading(true);

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: ""
//     };

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || ""
//       },
//       ...newGroup
//     };

//     axios.post(`${backendURL}/socialapp/groups/`, payload, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//     .then(response => {
//       Swal.fire({
//         icon: 'success',
//         title: 'Group Created!',
//         text: 'Your group has been created successfully.',
//       });

//       // Add the new group to the groups list
//       setGroups(prevGroups => [response.data, ...prevGroups]);

//       // Reset form and close modal
//       setNewGroup({
//         name: '',
//         description: '',
//         privacy: 'public',
//         is_active: true,
//         post_permission: 'admin_only',
//         invite_permission: 'user'
//       });
//       setShowCreateModal(false);

//       // Switch to all groups tab to see the new group
//       setActiveTab('all');
//     })
//     .catch(error => {
//       console.error('Error creating group:', error);
//       Swal.fire({
//         icon: 'error',
//         title: 'Error!',
//         text: 'Failed to create group. Please try again.',
//       });
//     })
//     .finally(() => {
//       setLoading(false);
//     });
//   };

//   // Filter groups based on search term
//   const filteredGroups = activeTab === 'all'
//     ? groups.filter(group =>
//         group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         group.description.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     : myGroups.filter(group =>
//         group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         group.description.toLowerCase().includes(searchTerm.toLowerCase())
//       );

//   // Render a group card
//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className='h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform'
//       style={{
//         background: '#fff',
//         borderRadius: '20px',
//         transition: 'transform 0.3s ease-in-out',
//         cursor: 'pointer'
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className='position-relative'>
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo
//                   .split('/')
//                   .pop()}`
//               : 'https://placehold.co/400x200?text=Group+Cover&font=roboto' // Default placeholder
//           }
//           alt='Group Cover'
//           className="img-fluid w-100 bg-light"
//           style={{
//             height: '220px',
//             objectFit: 'contain', // ⬅️ Ensures full image is visible
//             borderTopLeftRadius: '20px',
//             borderTopRightRadius: '20px',
//             backgroundColor: '#f0f0f0', // optional fallback for transparency
//           }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className='position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white'
//           style={{
//             fontSize: '12px',
//             background: 'rgba(0, 0, 0, 0.6)',
//             backdropFilter: 'blur(5px)',
//             textTransform: 'uppercase',
//           }}
//         >
//           {group.privacy === 'public' ? '🌍 Public' : '🔒 Private'}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className='position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white'
//           style={{
//             background:
//               'linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)',
//           }}
//         >
//           <h3
//             className='h5 fw-bold mb-1 text-truncate'
//             onClick={(e) => {
//               e.stopPropagation();
//               handleGroupClick(group.id);
//             }}
//             style={{ cursor: 'pointer', maxWidth: '90%' }}
//           >
//             {group.name || 'Unnamed Group'}
//           </h3>
//           <p className='small mb-0'>
//             Created by {group.created_by?.first_name || 'Unknown'}{' '}
//             {group.created_by?.last_name || ''}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className='p-4'>
//         <p
//           className='text-muted text-truncate'
//           style={{ minHeight: '50px', fontSize: '14px' }}
//         >
//           {group.description || 'No description available.'}
//         </p>

//         {/* Members & Join Button */}
//         <div className='d-flex justify-content-between align-items-center'>
//           <span
//             className='text-muted fw-semibold'
//             style={{ color: '#B8529E', fontSize: '1.2rem' }}
//           >
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === 'all' && (
//             <Button
//               variant={
//                 group.is_connected
//                   ? 'secondary'
//                   : group.is_pending
//                   ? 'warning'
//                   : 'primary'
//               }
//               size='sm'
//               className='rounded-pill px-4 shadow-sm'
//               style={{
//                 background: group.is_connected
//                   ? 'gray'
//                   : group.is_pending
//                   ? 'orange'
//                   : 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                 border: 'none',
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleJoinGroup(group.id, group.is_connected);
//               }}
//             >
//               {group.is_connected
//                 ? 'Joined'
//                 : group.is_pending
//                 ? 'Pending'
//                 : 'Join'}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   );

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal
//       show={showCreateModal}
//       onHide={() => setShowCreateModal(false)}
//       centered
//       size="lg"
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select
//                   name="privacy"
//                   value={newGroup.privacy}
//                   onChange={handleSelectChange}
//                 >
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === 'public'
//                     ? 'Anyone can see who\'s in the group and what they post.'
//                     : 'Only members can see who\'s in the group and what they post.'}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select
//                   name="post_permission"
//                   value={newGroup.post_permission}
//                   onChange={handleSelectChange}
//                 >
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   Who can post content in this group
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select
//               name="invite_permission"
//               value={newGroup.invite_permission}
//               onChange={handleSelectChange}
//             >
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">
//               Who can invite new members to the group
//             </Form.Text>
//           </Form.Group>

//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               style={{
//                 background: 'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                 border: 'none'
//               }}
//               disabled={loading}
//             >
//               {loading ? 'Creating...' : 'Create Group'}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   );

//   return (
//     <>
//     <Header />
//       <Container className='py-4'>
//         <div className='d-flex justify-content-between align-items-center mb-4' style={{ marginTop: '3.5rem' }}>
//           <h1 className='fw-bold'>Groups</h1>
//           <InputGroup style={{ width: '300px' }}>
//             <InputGroup.Text className='bg-white border-end-0'>
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder='Search Groups...'
//               className='border-start-0'
//               style={{ boxShadow: 'none' }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>

//         <Nav className='mb-4'>
//           {['all', 'my'].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor:
//                     activeTab === tab ? '#B8529E' : 'transparent',
//                   color: activeTab === tab ? 'white' : '#6c757d',
//                   borderRadius: '50px',
//                   padding: '8px 16px',
//                   transition: 'background-color 0.3s ease',
//                 }}
//               >
//                 {tab === 'all' ? 'All Groups' : 'My Groups'}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item>
//             <Nav.Link
//               onClick={() => setShowCreateModal(true)}
//               style={{
//                 backgroundColor: 'transparent',
//                 color: '#6c757d',
//                 borderRadius: '50px',
//                 padding: '8px 16px',
//                 transition: 'background-color 0.3s ease',
//               }}
//             >
//               Create a Group
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className='d-flex justify-content-between align-items-center mb-4'>
//           <p className='text-muted mb-0'>
//             Showing {filteredGroups.length} groups
//           </p>
//           <div className='d-flex gap-2'>
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant='outline-secondary'
//                 className='d-flex align-items-center gap-2'
//               >
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {['Recently Active', 'Most Members', 'Alphabetical'].map(
//                   (option) => (
//                     <Dropdown.Item
//                       key={option}
//                       onClick={() => setSortBy(option)}
//                     >
//                       {option}
//                     </Dropdown.Item>
//                   )
//                 )}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className='btn-group'>
//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'grid' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'grid' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('grid')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor:
//                     viewMode === 'list' ? '#B8529E' : 'transparent',
//                   borderColor: '#B8529E',
//                   color: viewMode === 'list' ? 'white' : '#B8529E',
//                 }}
//                 onClick={() => setViewMode('list')}
//                 className='d-flex align-items-center justify-content-center'
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <div className='text-center my-5'>
//             <Spinner animation='border' variant='primary' />
//             <p className='mt-2'>Loading groups...</p>
//           </div>
//         ) : (
//           <Row>
//             {filteredGroups.length > 0 ? (
//               filteredGroups.map((group) => (
//                 <Col md={6} lg={4} className='mb-4' key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className='col-12 text-center py-5'>
//                 <img
//                   src='https://cdn-icons-png.flaticon.com/512/4076/4076478.png'
//                   alt='No groups'
//                   style={{ width: '150px', opacity: 0.7, marginBottom: '20px' }}
//                 />
//                 <h4 className='text-muted'>No groups found</h4>
//                 <p className='text-muted mb-4'>
//                   {activeTab === 'my'
//                     ? "You haven't joined any groups yet."
//                     : "Be the first to create a group!"}
//                 </p>
//                 <Button
//                   variant='primary'
//                   onClick={() => setShowCreateModal(true)}
//                   style={{
//                     background:
//                       'linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)',
//                     border: 'none',
//                     padding: '10px 25px',
//                     borderRadius: '25px',
//                     fontWeight: '500',
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>

//       {/* Create Group Modal */}
//       {renderCreateGroupModal()}
//     </>
//   );
// }

// // For testing in Node.js environment
// if (typeof window === 'undefined') {
//   console.log('GroupsPage component created successfully');
//   console.log('This component includes:');
//   console.log('1. API integration for creating groups');
//   console.log('2. API integration for fetching user\'s groups');
//   console.log('3. Group listing with grid/list view options');
//   console.log('4. Group joining functionality');
//   console.log('5. Sorting and filtering capabilities');
// }

// export default GroupsPage;
"use client";

// import { useState, useEffect } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"
// import { Container, InputGroup, Form, Button, Card, Nav, Row, Col, Dropdown, Modal } from "react-bootstrap"
// import { Search, Grid3x3, List } from "react-bootstrap-icons"
// import Swal from "sweetalert2"
// import Header from "../Components/Header"
// import { motion } from "framer-motion"

// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState("all")
//   const [viewMode, setViewMode] = useState("grid")
//   const [sortBy, setSortBy] = useState("Most Members")
//   const [groups, setGroups] = useState([])
//   const [myGroups, setMyGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [showCreateModal, setShowCreateModal] = useState(false)
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])

//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: "",
//     description: "",
//     privacy: "public",
//     is_active: true,
//     post_permission: "admin_only",
//     invite_permission: "user",
//   })

//   const navigate = useNavigate()
//   const token = localStorage.getItem("jwttoken")
//   const backendURL = "https://kaasbackend.vetrinahealthcare.com"

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === "all") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const fetchedGroups = response.data
//           // Sort groups by most members first
//           fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//           setGroups(fetchedGroups)
//         })
//         .catch((error) => {
//           console.error("Error fetching groups:", error)
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Failed to load groups. Please try again later.",
//           })
//         })
//         .finally(() => {
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === "my") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data

//           // Get the group details for each membership
//           const groupPromises = memberships.map((membership) =>
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//           )

//           Promise.all(groupPromises)
//             .then((groupResponses) => {
//               const myGroupsData = groupResponses.map((res) => ({
//                 ...res.data,
//                 is_connected: true, // Mark as already joined
//               }))

//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy)
//               setMyGroups(myGroupsData)
//             })
//             .catch((error) => {
//               console.error("Error fetching group details:", error)
//             })
//             .finally(() => {
//               setLoading(false)
//             })
//         })
//         .catch((error) => {
//           console.error("Error fetching group memberships:", error)
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === "all") {
//       sortGroups([...groups], sortBy)
//     } else if (activeTab === "my") {
//       sortGroups([...myGroups], sortBy)
//     }
//   }, [sortBy])

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     const sortedGroups = [...groupsToSort]

//     if (criteria === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//     } else if (criteria === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//     } else if (criteria === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     if (activeTab === "all") {
//       setGroups(sortedGroups)
//     } else if (activeTab === "my") {
//       setMyGroups(sortedGroups)
//     }
//   }

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/group/${groupId}`)
//   }

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(`${backendURL}/socialapp/groups/${groupId}/join/`, {}, { headers: { Authorization: `Bearer ${token}` } })
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) => (group.id === groupId ? { ...group, is_pending: true } : group)),
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           })
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           })
//         }
//         console.error("Error joining group:", error)
//       })
//   }

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault()
//     setLoading(true)

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: "",
//     }

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || "",
//       },
//       ...newGroup,
//     }

//     axios
//       .post(`${backendURL}/socialapp/groups/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Group Created!",
//           text: "Your group has been created successfully.",
//         })

//         // Add the new group to the groups list
//         setGroups((prevGroups) => [response.data, ...prevGroups])

//         // Reset form and close modal
//         setNewGroup({
//           name: "",
//           description: "",
//           privacy: "public",
//           is_active: true,
//           post_permission: "admin_only",
//           invite_permission: "user",
//         })
//         setShowCreateModal(false)

//         // Switch to all groups tab to see the new group
//         setActiveTab("all")
//       })
//       .catch((error) => {
//         console.error("Error creating group:", error)
//         Swal.fire({
//           icon: "error",
//           title: "Error!",
//           text: "Failed to create group. Please try again.",
//         })
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }

//   // Filter groups based on search term
//   const filteredGroups =
//     activeTab === "all"
//       ? groups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : myGroups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )

//   // Group Card Skeleton
//   const GroupCardSkeleton = () => (
//     <Card
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//       }}
//     >
//       {/* Skeleton Cover Image */}
//       <div className="position-relative">
//         <div
//           style={{
//             height: "220px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//           }}
//         ></div>

//         {/* Skeleton Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2"
//           style={{
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//           }}
//         >
//           <div
//             style={{
//               height: "24px",
//               width: "70%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//               marginBottom: "8px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "16px",
//               width: "50%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <div
//           style={{
//             height: "50px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderRadius: "4px",
//             marginBottom: "15px",
//           }}
//         ></div>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <div
//             style={{
//               height: "24px",
//               width: "40%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "38px",
//               width: "30%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "20px",
//             }}
//           ></div>
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Render a group card
//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//         cursor: "pointer",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo.split("/db-shiksha/kaas/").pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="img-fluid w-100 bg-light"
//           style={{
//             height: "220px",
//             objectFit: "contain", // Ensures full image is visible
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//             backgroundColor: "#f0f0f0", // optional fallback for transparency
//           }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background: "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p className="text-muted text-truncate" style={{ minHeight: "50px", fontSize: "14px" }}>
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span className="text-muted fw-semibold" style={{ color: "#B8529E", fontSize: "1.2rem" }}>
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === "all" && (
//             <Button
//               variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
//               size="sm"
//               className="rounded-pill px-4 shadow-sm"
//               style={{
//                 background: group.is_connected
//                   ? "gray"
//                   : group.is_pending
//                     ? "orange"
//                     : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation()
//                 handleJoinGroup(group.id, group.is_connected)
//               }}
//             >
//               {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select name="privacy" value={newGroup.privacy} onChange={handleSelectChange}>
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === "public"
//                     ? "Anyone can see who's in the group and what they post."
//                     : "Only members can see who's in the group and what they post."}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select name="post_permission" value={newGroup.post_permission} onChange={handleSelectChange}>
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">Who can post content in this group</Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select name="invite_permission" value={newGroup.invite_permission} onChange={handleSelectChange}>
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">Who can invite new members to the group</Form.Text>
//           </Form.Group>

//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               style={{
//                 background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={loading}
//             >
//               {loading ? "Creating..." : "Create Group"}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   )

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4" style={{ marginTop: "3.5rem" }}>
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder="Search Groups..."
//               className="border-start-0"
//               style={{ boxShadow: "none" }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>

//         <Nav className="mb-4">
//           {["all", "my"].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//                   color: activeTab === tab ? "white" : "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 {tab === "all" ? "All Groups" : "My Groups"}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item>
//             <Nav.Link
//               onClick={() => setShowCreateModal(true)}
//               style={{
//                 backgroundColor: "transparent",
//                 color: "#6c757d",
//                 borderRadius: "50px",
//                 padding: "8px 16px",
//                 transition: "background-color 0.3s ease",
//               }}
//             >
//               Create a Group
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {filteredGroups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//               <Button
//                 style={{
//                   backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "grid" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("grid")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "list" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("list")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
//             <Row>
//               {Array(6)
//                 .fill(0)
//                 .map((_, index) => (
//                   <Col md={6} lg={4} className="mb-4" key={index}>
//                     <GroupCardSkeleton />
//                   </Col>
//                 ))}
//             </Row>
//           </motion.div>
//         ) : (
//           <Row>
//             {filteredGroups.length > 0 ? (
//               filteredGroups.map((group) => (
//                 <Col md={6} lg={4} className="mb-4" key={group.id}>
//                   {renderGroupCard(group)}
//                 </Col>
//               ))
//             ) : (
//               <div className="col-12 text-center py-5">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
//                   alt="No groups"
//                   style={{ width: "150px", opacity: 0.7, marginBottom: "20px" }}
//                 />
//                 <h4 className="text-muted">No groups found</h4>
//                 <p className="text-muted mb-4">
//                   {activeTab === "my" ? "You haven't joined any groups yet." : "Be the first to create a group!"}
//                 </p>
//                 <Button
//                   variant="primary"
//                   onClick={() => setShowCreateModal(true)}
//                   style={{
//                     background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                     border: "none",
//                     padding: "10px 25px",
//                     borderRadius: "25px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   Create Group
//                 </Button>
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>

//       {/* Create Group Modal */}
//       {renderCreateGroupModal()}


//     </>
//   )
// }

// export default GroupsPage

// "use client"

// import { useState, useEffect } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"
// import { Container, InputGroup, Form, Button, Card, Nav, Row, Col, Dropdown, Modal } from "react-bootstrap"
// import { Search, Grid3x3, List } from "react-bootstrap-icons"
// import Swal from "sweetalert2"
// import Header from "../Components/Header"
// import { motion } from "framer-motion"

// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState("all")
//   const [viewMode, setViewMode] = useState("grid")
//   const [sortBy, setSortBy] = useState("Most Members")
//   const [groups, setGroups] = useState([])
//   const [myGroups, setMyGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [showCreateModal, setShowCreateModal] = useState(false)
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])
//   const [userRole, setUserRole] = useState("") // State to store user role

//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: "",
//     description: "",
//     privacy: "public",
//     is_active: true,
//     post_permission: "admin_only",
//     invite_permission: "user",
//   })

//   const navigate = useNavigate()
//   const token = localStorage.getItem("jwttoken")
//   const backendURL = "https://kaasbackend.vetrinahealthcare.com"

//   // Fetch user info and determine role
//   useEffect(() => {
//     const userInfo = localStorage.getItem("role") || {}
//     // Check if role exists in userInfo, if not default to "student"
//     const role = userInfo || "student"
//     setUserRole(role)
//   }, [])

//   // Check if user can create groups (admin or instructor only)
//   const canCreateGroup = () => {
//     return userRole === "Admin" || userRole === "Instructor"
//   }

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === "all") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//          .then((response) => {
//         // Ensure we have an array and remove duplicates
//         const fetchedGroups = Array.isArray(response.data)
//           ? response.data.filter((group, index, self) =>
//               index === self.findIndex((g) => g.id === group.id)
//             )
//           : [];

//         // Sort groups by most members first
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//         setGroups(fetchedGroups);
//       })
//         .catch((error) => {
//           console.error("Error fetching groups:", error)
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Failed to load groups. Please try again later.",
//           })
//         })
//         .finally(() => {
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === "my") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data

//           // Get the group details for each membership
//           const groupPromises = memberships.map((membership) =>
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//           )

//           Promise.all(groupPromises)
//             .then((groupResponses) => {
//               const myGroupsData = groupResponses.map((res) => ({
//                 ...res.data,
//                 is_connected: true, // Mark as already joined
//               }))

//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy)
//               setMyGroups(myGroupsData)
//             })
//             .catch((error) => {
//               console.error("Error fetching group details:", error)
//             })
//             .finally(() => {
//               setLoading(false)
//             })
//         })
//         .catch((error) => {
//           console.error("Error fetching group memberships:", error)
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === "all") {
//       sortGroups([...groups], sortBy)
//     } else if (activeTab === "my") {
//       sortGroups([...myGroups], sortBy)
//     }
//   }, [sortBy])

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     const sortedGroups = [...groupsToSort]

//     if (criteria === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//     } else if (criteria === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//     } else if (criteria === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     if (activeTab === "all") {
//       setGroups(sortedGroups)
//     } else if (activeTab === "my") {
//       setMyGroups(sortedGroups)
//     }
//   }

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/db-shiksha/kaas/group/${groupId}`)
//   }

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(`${backendURL}/socialapp/groups/${groupId}/join/`, {}, { headers: { Authorization: `Bearer ${token}` } })
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) => (group.id === groupId ? { ...group, is_pending: true } : group)),
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           })
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           })
//         }
//         console.error("Error joining group:", error)
//       })
//   }

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault()
//     setLoading(true)

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: "",
//     }

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || "",
//       },
//       ...newGroup,
//     }

//     axios
//       .post(`${backendURL}/socialapp/groups/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Group Created!",
//           text: "Your group has been created successfully.",
//         })

//         // Add the new group to the groups list
//         setGroups((prevGroups) => [response.data, ...prevGroups])

//         // Reset form and close modal
//         setNewGroup({
//           name: "",
//           description: "",
//           privacy: "public",
//           is_active: true,
//           post_permission: "admin_only",
//           invite_permission: "user",
//         })
//         setShowCreateModal(false)

//         // Switch to all groups tab to see the new group
//         setActiveTab("all")
//       })
//       .catch((error) => {
//         console.error("Error creating group:", error)
//         Swal.fire({
//           icon: "error",
//           title: "Error!",
//           text: "Failed to create group. Please try again.",
//         })
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }

//   // Filter groups based on search term
//   const filteredGroups =
//     activeTab === "all"
//       ? groups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : myGroups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )

//   // Group Card Skeleton
//   const GroupCardSkeleton = () => (
//     <Card
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//       }}
//     >
//       {/* Skeleton Cover Image */}
//       <div className="position-relative">
//         <div
//           style={{
//             height: "220px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//           }}
//         ></div>

//         {/* Skeleton Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2"
//           style={{
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//           }}
//         >
//           <div
//             style={{
//               height: "24px",
//               width: "70%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//               marginBottom: "8px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "16px",
//               width: "50%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <div
//           style={{
//             height: "50px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderRadius: "4px",
//             marginBottom: "15px",
//           }}
//         ></div>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <div
//             style={{
//               height: "24px",
//               width: "40%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "38px",
//               width: "30%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "20px",
//             }}
//           ></div>
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Render a group card
//   const renderGroupCard = (group) => (
//     <Card
//       key={group.id}
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//         transition: "transform 0.3s ease-in-out",
//         cursor: "pointer",
//       }}
//       onClick={() => handleGroupClick(group.id)}
//     >
//       {/* Group Cover Image with Fallback */}
//       <div className="position-relative">
//         <img
//           src={
//             group.cover_photo
//               ? `${backendURL}/lms/media/group_covers/${group.cover_photo.split("/db-shiksha/kaas/").pop()}`
//               : "https://placehold.co/400x200?text=Group+Cover&font=roboto" // Default placeholder
//           }
//           alt="Group Cover"
//           className="img-fluid w-100 bg-light"
//           style={{
//             height: "220px",
//             objectFit: "contain", // Ensures full image is visible
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//             backgroundColor: "#f0f0f0", // optional fallback for transparency
//           }}
//         />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background: "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p className="text-muted text-truncate" style={{ minHeight: "50px", fontSize: "14px" }}>
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span className="text-muted fw-semibold" style={{ color: "#B8529E", fontSize: "1.2rem" }}>
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === "all" && (
//             <Button
//               variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
//               size="sm"
//               className="rounded-pill px-4 shadow-sm"
//               style={{
//                 background: group.is_connected
//                   ? "gray"
//                   : group.is_pending
//                     ? "orange"
//                     : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation()
//                 handleJoinGroup(group.id, group.is_connected)
//               }}
//             >
//               {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select name="privacy" value={newGroup.privacy} onChange={handleSelectChange}>
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === "public"
//                     ? "Anyone can see who's in the group and what they post."
//                     : "Only members can see who's in the group and what they post."}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select name="post_permission" value={newGroup.post_permission} onChange={handleSelectChange}>
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">Who can post content in this group</Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select name="invite_permission" value={newGroup.invite_permission} onChange={handleSelectChange}>
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">Who can invite new members to the group</Form.Text>
//           </Form.Group>

//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               style={{
//                 background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={loading}
//             >
//               {loading ? "Creating..." : "Create Group"}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   )

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4" style={{ marginTop: "3.5rem" }}>
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder="Search Groups..."
//               className="border-start-0"
//               style={{ boxShadow: "none" }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>

//         <Nav className="mb-4">
//           {["all", "my"].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//                   color: activeTab === tab ? "white" : "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 {tab === "all" ? "All Groups" : "My Groups"}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           {/* Only show Create Group tab for instructors and admins */}
//           {canCreateGroup() && (
//             <Nav.Item>
//               <Nav.Link
//                 onClick={() => setShowCreateModal(true)}
//                 style={{
//                   backgroundColor: "transparent",
//                   color: "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 Create a Group
//               </Nav.Link>
//             </Nav.Item>
//           )}
//         </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {filteredGroups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//               <Button
//                 style={{
//                   backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "grid" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("grid")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "list" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("list")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
//             <Row>
//               {Array(6)
//                 .fill(0)
//                 .map((_, index) => (
//                   <Col md={6} lg={4} className="mb-4" key={index}>
//                     <GroupCardSkeleton />
//                   </Col>
//                 ))}
//             </Row>
//           </motion.div>
//         ) : (
//           <Row>
//            {filteredGroups.length > 0 ? (
//   filteredGroups.map((group) => (
//     <Col md={6} lg={4} className="mb-4" key={group.id}>
//       {renderGroupCard(group)}
//     </Col>
//   ))
// ): (
//               <div className="col-12 text-center py-5">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
//                   alt="No groups"
//                   style={{ width: "150px", opacity: 0.7, marginBottom: "20px" }}
//                 />
//                 <h4 className="text-muted">No groups found</h4>
//                 <p className="text-muted mb-4">
//                   {activeTab === "my" ? "You haven't joined any groups yet." : "No groups are available right now."}
//                 </p>
//                 {/* Only show Create Group button for instructors and admins */}
//                 {canCreateGroup() && (
//                   <Button
//                     variant="primary"
//                     onClick={() => setShowCreateModal(true)}
//                     style={{
//                       background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                       border: "none",
//                       padding: "10px 25px",
//                       borderRadius: "25px",
//                       fontWeight: "500",
//                     }}
//                   >
//                     Create Group
//                   </Button>
//                 )}
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>

//       {/* Create Group Modal - Will only be accessible by instructors and admins */}
//       {canCreateGroup() && renderCreateGroupModal()}


//     </>
//   )
// }

// export default GroupsPage;

// import { useState, useEffect } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"
// import { Container, InputGroup, Form, Button, Card, Nav, Row, Col, Dropdown, Modal } from "react-bootstrap"
// import { Search, Grid3x3, List } from "react-bootstrap-icons"
// import Swal from "sweetalert2"
// import Header from "../Components/Header"
// import { motion } from "framer-motion"

// // Main component
// function GroupsPage() {
//   const [activeTab, setActiveTab] = useState("all")
//   const [viewMode, setViewMode] = useState("grid")
//   const [sortBy, setSortBy] = useState("Most Members")
//   const [groups, setGroups] = useState([])
//   const [myGroups, setMyGroups] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [searchTerm, setSearchTerm] = useState("")
//   const [showCreateModal, setShowCreateModal] = useState(false)
//   const [pendingJoinRequests, setPendingJoinRequests] = useState([])
//   const [userRole, setUserRole] = useState("") // State to store user role

//   // Form state for creating a group
//   const [newGroup, setNewGroup] = useState({
//     name: "",
//     description: "",
//     privacy: "public",
//     is_active: true,
//     post_permission: "admin_only",
//     invite_permission: "user",
//   })

//   const navigate = useNavigate()
//   const token = localStorage.getItem("jwttoken")
//   const backendURL = "https://kaasbackend.vetrinahealthcare.com"

//   // Fetch user info and determine role
//   useEffect(() => {
//     const userInfo = localStorage.getItem("role") || {}
//     // Check if role exists in userInfo, if not default to "student"
//     const role = userInfo || "student"
//     setUserRole(role)
//   }, [])

//   // Check if user can create groups (admin or instructor only)
//   const canCreateGroup = () => {
//     return userRole === "Admin" || userRole === "Instructor"
//   }

//   // Fetch all groups
//   useEffect(() => {
//     if (activeTab === "all") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/groups/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//          .then((response) => {
//         // Ensure we have an array and remove duplicates
//         const fetchedGroups = Array.isArray(response.data)
//           ? response.data.filter((group, index, self) =>
//               index === self.findIndex((g) => g.id === group.id)
//             )
//           : [];

//         // Sort groups by most members first
//         fetchedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0));
//         setGroups(fetchedGroups);
//       })
//         .catch((error) => {
//           console.error("Error fetching groups:", error)
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Failed to load groups. Please try again later.",
//           })
//         })
//         .finally(() => {
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Fetch my groups
//   useEffect(() => {
//     if (activeTab === "my") {
//       setLoading(true)
//       axios
//         .get(`${backendURL}/socialapp/group_memberships/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//         .then((response) => {
//           const memberships = response.data

//           // Get the group details for each membership
//           const groupPromises = memberships.map((membership) =>
//             axios.get(`${backendURL}/socialapp/groups/${membership.group}/`, {
//               headers: { Authorization: `Bearer ${token}` },
//             }),
//           )

//           Promise.all(groupPromises)
//             .then((groupResponses) => {
//               const myGroupsData = groupResponses.map((res) => ({
//                 ...res.data,
//                 is_connected: true, // Mark as already joined
//               }))

//               // Sort by the selected criteria
//               sortGroups(myGroupsData, sortBy)
//               setMyGroups(myGroupsData)
//             })
//             .catch((error) => {
//               console.error("Error fetching group details:", error)
//             })
//             .finally(() => {
//               setLoading(false)
//             })
//         })
//         .catch((error) => {
//           console.error("Error fetching group memberships:", error)
//           setLoading(false)
//         })
//     }
//   }, [token, activeTab])

//   // Sort groups when sort criteria changes
//   useEffect(() => {
//     if (activeTab === "all") {
//       sortGroups([...groups], sortBy)
//     } else if (activeTab === "my") {
//       sortGroups([...myGroups], sortBy)
//     }
//   }, [sortBy])

//   // Function to sort groups based on criteria
//   const sortGroups = (groupsToSort, criteria) => {
//     const sortedGroups = [...groupsToSort]

//     if (criteria === "Recently Active") {
//       sortedGroups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//     } else if (criteria === "Most Members") {
//       sortedGroups.sort((a, b) => (b.members?.length || 0) - (a.members?.length || 0))
//     } else if (criteria === "Alphabetical") {
//       sortedGroups.sort((a, b) => a.name.localeCompare(b.name))
//     }

//     if (activeTab === "all") {
//       setGroups(sortedGroups)
//     } else if (activeTab === "my") {
//       setMyGroups(sortedGroups)
//     }
//   }

//   // Handle group click to navigate to group details
//   const handleGroupClick = (groupId) => {
//     navigate(`/db-shiksha/kaas/group/${groupId}`)
//   }

//   // Handle joining a group
//   const handleJoinGroup = (groupId, isMember) => {
//     if (isMember) {
//       Swal.fire({
//         icon: "info",
//         title: "You're already a member!",
//         text: "You have already joined this group.",
//       })
//       return
//     }

//     setPendingJoinRequests((prev) => [...prev, groupId]) // Set to pending

//     axios
//       .post(`${backendURL}/socialapp/groups/${groupId}/join/`, {}, { headers: { Authorization: `Bearer ${token}` } })
//       .then(() => {
//         Swal.fire({
//           icon: "success",
//           title: "Join Request Submitted!",
//           text: "Your request has been sent. Waiting for approval.",
//         })

//         // Update group state to show 'Pending'
//         setGroups((prevGroups) =>
//           prevGroups.map((group) => (group.id === groupId ? { ...group, is_pending: true } : group)),
//         )
//       })
//       .catch((error) => {
//         setPendingJoinRequests((prev) => prev.filter((id) => id !== groupId)) // Remove from pending

//         if (error.response?.status === 409) {
//           Swal.fire({
//             icon: "info",
//             title: "You're already a member!",
//             text: "You have already joined this group.",
//           })
//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Error!",
//             text: "Something went wrong while joining the group.",
//           })
//         }
//         console.error("Error joining group:", error)
//       })
//   }

//   // Handle input change for create group form
//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Handle select change for create group form
//   const handleSelectChange = (e) => {
//     const { name, value } = e.target
//     setNewGroup({
//       ...newGroup,
//       [name]: value,
//     })
//   }

//   // Create a new group
//   const handleCreateGroup = (e) => {
//     e.preventDefault()
//     setLoading(true)

//     // Get user info from localStorage or another source
//     const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {
//       first_name: "User",
//       last_name: "Name",
//       email: "user@example.com",
//       profile_pic: "",
//     }

//     const payload = {
//       created_by: {
//         first_name: userInfo.first_name,
//         last_name: userInfo.last_name,
//         email: userInfo.email,
//         profile_pic: userInfo.profile_pic || "",
//       },
//       ...newGroup,
//     }

//     axios
//       .post(`${backendURL}/socialapp/groups/`, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((response) => {
//         Swal.fire({
//           icon: "success",
//           title: "Group Created!",
//           text: "Your group has been created successfully.",
//         })

//         // Add the new group to the groups list
//         setGroups((prevGroups) => [response.data, ...prevGroups])

//         // Reset form and close modal
//         setNewGroup({
//           name: "",
//           description: "",
//           privacy: "public",
//           is_active: true,
//           post_permission: "admin_only",
//           invite_permission: "user",
//         })
//         setShowCreateModal(false)

//         // Switch to all groups tab to see the new group
//         setActiveTab("all")
//       })
//       .catch((error) => {
//         console.error("Error creating group:", error)
//         Swal.fire({
//           icon: "error",
//           title: "Error!",
//           text: "Failed to create group. Please try again.",
//         })
//       })
//       .finally(() => {
//         setLoading(false)
//       })
//   }

//   // Filter groups based on search term
//   const filteredGroups =
//     activeTab === "all"
//       ? groups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )
//       : myGroups.filter(
//           (group) =>
//             group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             group.description.toLowerCase().includes(searchTerm.toLowerCase()),
//         )

//   // Group Card Skeleton
//   const GroupCardSkeleton = () => (
//     <Card
//       className="h-100 border-0 rounded-4 overflow-hidden shadow-lg"
//       style={{
//         background: "#fff",
//         borderRadius: "20px",
//       }}
//     >
//       {/* Skeleton Cover Image */}
//       <div className="position-relative">
//         <div
//           style={{
//             height: "220px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderTopLeftRadius: "20px",
//             borderTopRightRadius: "20px",
//           }}
//         ></div>

//         {/* Skeleton Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2"
//           style={{
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//           }}
//         >
//           <div
//             style={{
//               height: "24px",
//               width: "70%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//               marginBottom: "8px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "16px",
//               width: "50%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <div
//           style={{
//             height: "50px",
//             background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//             backgroundSize: "200% 100%",
//             animation: "shimmer 1.5s infinite",
//             borderRadius: "4px",
//             marginBottom: "15px",
//           }}
//         ></div>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <div
//             style={{
//               height: "24px",
//               width: "40%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "4px",
//             }}
//           ></div>
//           <div
//             style={{
//               height: "38px",
//               width: "30%",
//               background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
//               backgroundSize: "200% 100%",
//               animation: "shimmer 1.5s infinite",
//               borderRadius: "20px",
//             }}
//           ></div>
//         </div>
//       </Card.Body>
//     </Card>
//   )
//   const getGroupCoverPhoto = (groupId) => {
//   // Array of placeholder image URLs
//   const placeholderImages = [
//     "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
//     "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
//     "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
//     "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
//   ];

//   // Use modulo to cycle through the images based on group ID
//   return placeholderImages[groupId % placeholderImages.length];
// };

//   // Render a group card
//  const renderGroupCard = (group) => (
//   <Card
//     key={group.id}
//     className="h-100 border-0 rounded-4 overflow-hidden shadow-lg transition-transform"
//     style={{
//       background: "#fff",
//       borderRadius: "20px",
//       transition: "transform 0.3s ease-in-out",
//       cursor: "pointer",
//     }}
//     onClick={() => handleGroupClick(group.id)}
//   >
//     {/* Group Cover Image with Fallback */}
//     <div className="position-relative">
//       <img
//         src={getGroupCoverPhoto(group.id)}  // Use the function here
//         alt="Group Cover"
//         className="img-fluid w-100 bg-light"
//         style={{
//           height: "220px",
//           objectFit: "cover",  // Changed from "contain" to "cover" for better appearance
//           borderTopLeftRadius: "20px",
//           borderTopRightRadius: "20px",
//           backgroundColor: "#f0f0f0",
//         }}
//       />
//         {/* Privacy Badge */}
//         <span
//           className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill text-white"
//           style={{
//             fontSize: "12px",
//             background: "rgba(0, 0, 0, 0.6)",
//             backdropFilter: "blur(5px)",
//             textTransform: "uppercase",
//           }}
//         >
//           {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
//         </span>

//         {/* Gradient Overlay */}
//         <div
//           className="position-absolute bottom-0 start-0 w-100 px-3 py-2 text-white"
//           style={{
//             background: "linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent)",
//           }}
//         >
//           <h3
//             className="h5 fw-bold mb-1 text-truncate"
//             onClick={(e) => {
//               e.stopPropagation()
//               handleGroupClick(group.id)
//             }}
//             style={{ cursor: "pointer", maxWidth: "90%" }}
//           >
//             {group.name || "Unnamed Group"}
//           </h3>
//           <p className="small mb-0">
//             Created by {group.created_by?.first_name || "Unknown"} {group.created_by?.last_name || ""}
//           </p>
//         </div>
//       </div>

//       {/* Card Body */}
//       <Card.Body className="p-4">
//         <p className="text-muted text-truncate" style={{ minHeight: "50px", fontSize: "14px" }}>
//           {group.description || "No description available."}
//         </p>

//         {/* Members & Join Button */}
//         <div className="d-flex justify-content-between align-items-center">
//           <span className="text-muted fw-semibold" style={{ color: "#B8529E", fontSize: "1.2rem" }}>
//             👥 {group.members?.length || 0} Members
//           </span>
//           {activeTab === "all" && (
//             <Button
//               variant={group.is_connected ? "secondary" : group.is_pending ? "warning" : "primary"}
//               size="sm"
//               className="rounded-pill px-4 shadow-sm"
//               style={{
//                 background: group.is_connected
//                   ? "gray"
//                   : group.is_pending
//                     ? "orange"
//                     : "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={group.is_connected || group.is_pending}
//               onClick={(e) => {
//                 e.stopPropagation()
//                 handleJoinGroup(group.id, group.is_connected)
//               }}
//             >
//               {group.is_connected ? "Joined" : group.is_pending ? "Pending" : "Join"}
//             </Button>
//           )}
//         </div>
//       </Card.Body>
//     </Card>
//   )

//   // Create Group Modal
//   const renderCreateGroupModal = () => (
//     <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
//       <Modal.Header closeButton>
//         <Modal.Title>Create a New Group</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form onSubmit={handleCreateGroup}>
//           <Form.Group className="mb-3">
//             <Form.Label>Group Name*</Form.Label>
//             <Form.Control
//               type="text"
//               name="name"
//               value={newGroup.name}
//               onChange={handleInputChange}
//               placeholder="Enter group name"
//               required
//             />
//           </Form.Group>

//           <Form.Group className="mb-3">
//             <Form.Label>Description</Form.Label>
//             <Form.Control
//               as="textarea"
//               name="description"
//               value={newGroup.description}
//               onChange={handleInputChange}
//               placeholder="Describe your group"
//               rows={3}
//             />
//           </Form.Group>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Privacy</Form.Label>
//                 <Form.Select name="privacy" value={newGroup.privacy} onChange={handleSelectChange}>
//                   <option value="public">Public</option>
//                   <option value="private">Private</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">
//                   {newGroup.privacy === "public"
//                     ? "Anyone can see who's in the group and what they post."
//                     : "Only members can see who's in the group and what they post."}
//                 </Form.Text>
//               </Form.Group>
//             </Col>
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Post Permission</Form.Label>
//                 <Form.Select name="post_permission" value={newGroup.post_permission} onChange={handleSelectChange}>
//                   <option value="admin_only">Admin Only</option>
//                   <option value="all_members">All Members</option>
//                 </Form.Select>
//                 <Form.Text className="text-muted">Who can post content in this group</Form.Text>
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Invite Permission</Form.Label>
//             <Form.Select name="invite_permission" value={newGroup.invite_permission} onChange={handleSelectChange}>
//               <option value="admin_only">Admin Only</option>
//               <option value="user">All Members</option>
//             </Form.Select>
//             <Form.Text className="text-muted">Who can invite new members to the group</Form.Text>
//           </Form.Group>

//           <div className="d-flex justify-content-end gap-2 mt-4">
//             <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
//               Cancel
//             </Button>
//             <Button
//               type="submit"
//               style={{
//                 background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                 border: "none",
//               }}
//               disabled={loading}
//             >
//               {loading ? "Creating..." : "Create Group"}
//             </Button>
//           </div>
//         </Form>
//       </Modal.Body>
//     </Modal>
//   )

//   return (
//     <>
//       <Header />
//       <Container className="py-4">
//         <div className="d-flex justify-content-between align-items-center mb-4" style={{ marginTop: "3.5rem" }}>
//           <h1 className="fw-bold">Groups</h1>
//           <InputGroup style={{ width: "300px" }}>
//             <InputGroup.Text className="bg-white border-end-0">
//               <Search />
//             </InputGroup.Text>
//             <Form.Control
//               placeholder="Search Groups..."
//               className="border-start-0"
//               style={{ boxShadow: "none" }}
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </div>

//         <Nav className="mb-4">
//           {["all", "my"].map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 style={{
//                   backgroundColor: activeTab === tab ? "#B8529E" : "transparent",
//                   color: activeTab === tab ? "white" : "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 {tab === "all" ? "All Groups" : "My Groups"}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           {/* Only show Create Group tab for instructors and admins */}
//           {canCreateGroup() && (
//             <Nav.Item>
//               <Nav.Link
//                 onClick={() => setShowCreateModal(true)}
//                 style={{
//                   backgroundColor: "transparent",
//                   color: "#6c757d",
//                   borderRadius: "50px",
//                   padding: "8px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//               >
//                 Create a Group
//               </Nav.Link>
//             </Nav.Item>
//           )}
//         </Nav>

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <p className="text-muted mb-0">Showing {filteredGroups.length} groups</p>
//           <div className="d-flex gap-2">
//             <Dropdown>
//               <Dropdown.Toggle variant="outline-secondary" className="d-flex align-items-center gap-2">
//                 {sortBy}
//               </Dropdown.Toggle>
//               <Dropdown.Menu>
//                 {["Recently Active", "Most Members", "Alphabetical"].map((option) => (
//                   <Dropdown.Item key={option} onClick={() => setSortBy(option)}>
//                     {option}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <div className="btn-group">
//               <Button
//                 style={{
//                   backgroundColor: viewMode === "grid" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "grid" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("grid")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <Grid3x3 />
//               </Button>

//               <Button
//                 style={{
//                   backgroundColor: viewMode === "list" ? "#B8529E" : "transparent",
//                   borderColor: "#B8529E",
//                   color: viewMode === "list" ? "white" : "#B8529E",
//                 }}
//                 onClick={() => setViewMode("list")}
//                 className="d-flex align-items-center justify-content-center"
//               >
//                 <List />
//               </Button>
//             </div>
//           </div>
//         </div>

//         {loading ? (
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
//             <Row>
//               {Array(6)
//                 .fill(0)
//                 .map((_, index) => (
//                   <Col md={6} lg={4} className="mb-4" key={index}>
//                     <GroupCardSkeleton />
//                   </Col>
//                 ))}
//             </Row>
//           </motion.div>
//         ) : (
//           <Row>
//            {filteredGroups.length > 0 ? (
//   filteredGroups.map((group) => (
//     <Col md={6} lg={4} className="mb-4" key={group.id}>
//       {renderGroupCard(group)}
//     </Col>
//   ))
// ): (
//               <div className="col-12 text-center py-5">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
//                   alt="No groups"
//                   style={{ width: "150px", opacity: 0.7, marginBottom: "20px" }}
//                 />
//                 <h4 className="text-muted">No groups found</h4>
//                 <p className="text-muted mb-4">
//                   {activeTab === "my" ? "You haven't joined any groups yet." : "No groups are available right now."}
//                 </p>
//                 {/* Only show Create Group button for instructors and admins */}
//                 {canCreateGroup() && (
//                   <Button
//                     variant="primary"
//                     onClick={() => setShowCreateModal(true)}
//                     style={{
//                       background: "linear-gradient(90.05deg, #B8529E 0.04%, #7D52A0 154.19%)",
//                       border: "none",
//                       padding: "10px 25px",
//                       borderRadius: "25px",
//                       fontWeight: "500",
//                     }}
//                   >
//                     Create Group
//                   </Button>
//                 )}
//               </div>
//             )}
//           </Row>
//         )}
//       </Container>

//       {/* Create Group Modal - Will only be accessible by instructors and admins */}
//       {canCreateGroup() && renderCreateGroupModal()}


//     </>
//   )
// }

// export default GroupsPage;
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Container,
  InputGroup,
  Form,
  Button,
  Card,
  Nav,
  Row,
  Col,
  Dropdown,
  Modal,
} from "react-bootstrap";
import { Search, Grid3x3, List } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import Header from "../Components/Header";
import { motion } from "framer-motion";
import { useTheme, Box } from "@mui/material";
import StudentSidebar from "./StudentSdebar";

// Main Component
function GroupsPage() {
  const [activeTab, setActiveTab] = useState("all");
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [viewMode, setViewMode] = useState("grid");
  const [sortBy, setSortBy] = useState("Most Members");
  const [groups, setGroups] = useState([]);
  const [myGroups, setMyGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [newGroup, setNewGroup] = useState({
    name: "",
    description: "",
    privacy: "public",
    post_permission: "admin_only",
    invite_permission: "user",
  });

  const navigate = useNavigate();
  const token = localStorage.getItem("jwttoken");
  const backendURL = "https://tdtlworld.com/dss-kaas-backend";
  const theme = useTheme();

  useEffect(() => {
    const role = localStorage.getItem("role") || "student";
    setUserRole(role);
  }, []);

  const canCreateGroup = () =>
    userRole === "Admin" || userRole === "Instructor";

  const fetchAllGroups = () => {
    setLoading(true);
    axios
      .get(`${backendURL}/socialapp/groups/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const fetchedGroups = Array.isArray(response.data) ? response.data : [];
        sortGroups(fetchedGroups, "Most Members", setGroups); // Default sort
      })
      .catch((error) => {
        console.error("Error fetching groups:", error);
        Swal.fire({
          icon: "error",
          title: "Load Error",
          text: "Failed to load groups.",
        });
      })
      .finally(() => setLoading(false));
  };

  const fetchMyGroups = () => {
    setLoading(true);
    axios
      .get(`${backendURL}/socialapp/group_memberships/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const memberships = Array.isArray(response.data) ? response.data : [];
        if (memberships.length === 0) {
          setMyGroups([]);
          setLoading(false);
          return;
        }
        const groupPromises = memberships.map((mem) =>
          axios.get(`${backendURL}/socialapp/groups/${mem.group}/`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        );
        Promise.all(groupPromises)
          .then((groupResponses) => {
            const myGroupsData = groupResponses.map((res) => ({
              ...res.data,
              is_connected: true,
            }));
            sortGroups(myGroupsData, "Most Members", setMyGroups); // Default sort
          })
          .catch((err) => console.error("Error fetching group details:", err))
          .finally(() => setLoading(false));
      })
      .catch((error) => {
        console.error("Error fetching memberships:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (activeTab === "all") fetchAllGroups();
    else if (activeTab === "my") fetchMyGroups();
  }, [token, activeTab]);

  useEffect(() => {
    const groupsToSort = activeTab === "all" ? [...groups] : [...myGroups];
    const setter = activeTab === "all" ? setGroups : setMyGroups;
    sortGroups(groupsToSort, sortBy, setter);
  }, [sortBy]);

  const sortGroups = (groupsToSort, criteria, setter) => {
    const sorted = [...groupsToSort].sort((a, b) => {
      if (criteria === "Recently Active")
        return new Date(b.created_at) - new Date(a.created_at);
      if (criteria === "Most Members")
        return (b.members?.length || 0) - (a.members?.length || 0);
      if (criteria === "Alphabetical") return a.name.localeCompare(b.name);
      return 0;
    });
    setter(sorted);
  };

  const handleGroupClick = (groupId) => {
    navigate(`/db-shiksha/kaas/student/group/${groupId}`);
  };

  const handleJoinGroup = (groupId, isMember) => {
    if (isMember) return;
    axios
      .post(
        `${backendURL}/socialapp/groups/${groupId}/join/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Request Sent!",
          text: "Your request to join has been sent for approval.",
          confirmButtonColor: theme.palette.primary.main,
        });
        setGroups((prev) =>
          prev.map((g) => (g.id === groupId ? { ...g, is_pending: true } : g)),
        );
      })
      .catch((error) => {
        const errorMsg =
          error.response?.status === 409
            ? "You have already joined this group."
            : "Failed to join group.";
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMsg,
          confirmButtonColor: theme.palette.primary.main,
        });
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewGroup((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateGroup = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(`${backendURL}/socialapp/groups/`, newGroup, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Group Created!",
          text: "Your new group is live.",
          confirmButtonColor: theme.palette.primary.main,
        });
        setGroups((prev) => [response.data, ...prev]);
        setShowCreateModal(false);
        setNewGroup({
          name: "",
          description: "",
          privacy: "public",
          post_permission: "admin_only",
          invite_permission: "user",
        });
        setActiveTab("all");
      })
      .catch(() =>
        Swal.fire({
          icon: "error",
          title: "Creation Failed",
          text: "Could not create the group.",
          confirmButtonColor: theme.palette.primary.main,
        }),
      )
      .finally(() => setLoading(false));
  };

  const currentGroups = activeTab === "all" ? groups : myGroups;
  const filteredGroups = currentGroups.filter(
    (group) =>
      group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      group.description.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const getGroupCoverPhoto = (groupId) => {
    const placeholders = [
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
      "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    ];
    return placeholders[groupId % placeholders.length];
  };

  const GroupCardSkeleton = () => (
    <Card className="h-100 border-0 rounded-4 overflow-hidden shadow-sm">
      <div className="skeleton-image" style={{ height: "220px" }}></div>
      <Card.Body className="p-4">
        <div
          className="skeleton-line mb-2"
          style={{ height: "24px", width: "70%" }}
        ></div>
        <div
          className="skeleton-line"
          style={{ height: "40px", width: "100%" }}
        ></div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div
            className="skeleton-line"
            style={{ height: "24px", width: "40%" }}
          ></div>
          <div
            className="skeleton-button"
            style={{ height: "38px", width: "80px" }}
          ></div>
        </div>
      </Card.Body>
    </Card>
  );

  const renderGroupCard = (group) => (
    <Card
      key={group.id}
      className="h-100 border-0 rounded-4 overflow-hidden shadow-sm group-card"
      onClick={() => handleGroupClick(group.id)}
    >
      <div className="position-relative">
        <img
          src={getGroupCoverPhoto(group.id)}
          alt="Group Cover"
          className="card-img-top"
        />
        <span className="privacy-badge">
          {group.privacy === "public" ? "🌍 Public" : "🔒 Private"}
        </span>
        <div className="card-img-overlay d-flex flex-column justify-content-end text-white p-3">
          <h3 className="h5 fw-bold mb-1 text-truncate">
            {group.name || "Unnamed Group"}
          </h3>
          <p className="small mb-0">
            Created by {group.created_by?.first_name || "Admin"}
          </p>
        </div>
      </div>
      <Card.Body className="p-4">
        <p className="text-muted description-truncate">
          {group.description || "No description available."}
        </p>
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold members-count">
            👥 {group.members?.length || 0} Members
          </span>
          {activeTab === "all" && (
            <Button
              size="sm"
              className="rounded-pill px-4 shadow-sm join-button"
              disabled={group.is_connected || group.is_pending}
              onClick={(e) => {
                e.stopPropagation();
                handleJoinGroup(group.id, group.is_connected);
              }}
            >
              {group.is_connected
                ? "Joined"
                : group.is_pending
                  ? "Pending"
                  : "Join"}
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );

  const renderCreateGroupModal = () => (
    <Modal
      show={showCreateModal}
      onHide={() => setShowCreateModal(false)}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title
          style={{ color: theme.palette.primary.main, fontWeight: "bold" }}
        >
          Create a New Group
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleCreateGroup}>
          <Form.Group className="mb-3">
            <Form.Label>Group Name*</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={newGroup.name}
              onChange={handleInputChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={newGroup.description}
              onChange={handleInputChange}
              rows={3}
            />
          </Form.Group>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Privacy</Form.Label>
                <Form.Select
                  name="privacy"
                  value={newGroup.privacy}
                  onChange={handleInputChange}
                >
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Post Permission</Form.Label>
                <Form.Select
                  name="post_permission"
                  value={newGroup.post_permission}
                  onChange={handleInputChange}
                >
                  <option value="admin_only">Admin Only</option>
                  <option value="all_members">All Members</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Invite Permission</Form.Label>
            <Form.Select
              name="invite_permission"
              value={newGroup.invite_permission}
              onChange={handleInputChange}
            >
              <option value="admin_only">Admin Only</option>
              <option value="user">All Members</option>
            </Form.Select>
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button
              variant="secondary"
              onClick={() => setShowCreateModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="create-group-button"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Group"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Header />
      <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
        <StudentSidebar onToggle={setSidebarExpanded} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: sidebarExpanded ? "calc(100% - 260px)" : "calc(100% - 80px)",
            transition: theme.transitions.create("width", { duration: 300 }),
            height: "calc(100vh - 64px)",
            overflowY: "auto",
          }}
        >
          <Container className="page-container">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1
                className="fw-bold"
                style={{
                  color:
                    theme.palette.mode === "dark"
                      ? "#FFFFFF"
                      : theme.palette.primary.main,
                }}
              >
                Groups
              </h1>
              <InputGroup className="search-bar">
                <InputGroup.Text>
                  <Search />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Search Groups..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </div>

            <Nav variant="pills" className="mb-4 group-nav">
              <Nav.Item>
                <Nav.Link
                  active={activeTab === "all"}
                  onClick={() => setActiveTab("all")}
                >
                  All Groups
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  active={activeTab === "my"}
                  onClick={() => setActiveTab("my")}
                >
                  My Groups
                </Nav.Link>
              </Nav.Item>
              {canCreateGroup() && (
                <Nav.Item>
                  <Nav.Link onClick={() => setShowCreateModal(true)}>
                    + Create Group
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>

            <div className="d-flex justify-content-between align-items-center mb-4">
              <p
                className={`mb-0 ${theme.palette.mode === "dark" ? "text-white" : "text-black"}`}
              >
                Showing {filteredGroups.length} groups
              </p>
              <div className="d-flex gap-2">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="d-flex align-items-center gap-2"
                  >
                    {sortBy}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["Recently Active", "Most Members", "Alphabetical"].map(
                      (option) => (
                        <Dropdown.Item
                          key={option}
                          onClick={() => setSortBy(option)}
                        >
                          {option}
                        </Dropdown.Item>
                      ),
                    )}
                  </Dropdown.Menu>
                </Dropdown>
                <div className="btn-group view-toggle">
                  <Button
                    active={viewMode === "grid"}
                    onClick={() => setViewMode("grid")}
                  >
                    <Grid3x3 />
                  </Button>
                  <Button
                    active={viewMode === "list"}
                    onClick={() => setViewMode("list")}
                  >
                    <List />
                  </Button>
                </div>
              </div>
            </div>

            {loading ? (
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <Row>
                  {Array(6)
                    .fill(0)
                    .map((_, i) => (
                      <Col md={6} lg={4} className="mb-4" key={i}>
                        <GroupCardSkeleton />
                      </Col>
                    ))}
                </Row>
              </motion.div>
            ) : (
              <Row>
                {filteredGroups.length > 0 ? (
                  filteredGroups.map((group) => (
                    <Col md={6} lg={4} className="mb-4" key={group.id}>
                      {renderGroupCard(group)}
                    </Col>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
                      alt="No groups"
                      className="no-groups-img"
                    />
                    <h4 className="text-muted">No Groups Found</h4>
                    <p className="text-muted mb-4">
                      {activeTab === "my"
                        ? "You haven't joined any groups yet."
                        : "No groups match your search."}
                    </p>
                    {canCreateGroup() && (
                      <Button
                        className="create-group-button"
                        onClick={() => setShowCreateModal(true)}
                      >
                        Create Your First Group
                      </Button>
                    )}
                  </div>
                )}
              </Row>
            )}
          </Container>

          {canCreateGroup() && renderCreateGroupModal()}

          <style>{`
            .page-container {
            }
            .page-title {
              color: ${theme.palette.mode === "dark"
                ? "#FFFFFF"
                : theme.palette.primary.main};
            }
            .search-bar {
              width: 300px;
            }
            .search-bar .form-control,
            .search-bar .input-group-text {
              border-color: ${theme.palette.divider};
              background-color: ${theme.palette.background.paper};
              color: ${theme.palette.text.primary};
            }
            .search-bar .form-control::placeholder {
              color: ${theme.palette.text.secondary};
              opacity: 0.7;
            }
            .search-bar .input-group-text {
              color: ${theme.palette.text.secondary};
            }
            .search-bar .form-control:focus {
              box-shadow: 0 0 0 0.25rem rgba(212, 175, 55, 0.25);
              border-color: ${theme.palette.primary.main};
            }

            .group-nav .nav-link {
              color: ${theme.palette.text.secondary};
              border-radius: 50px;
              padding: 8px 16px;
              font-weight: 500;
            }
            .group-nav .nav-link.active {
              background-color: ${theme.palette.primary.main};
              color: ${theme.palette.primary.contrastText};
            }

            .view-toggle .btn {
              background-color: ${theme.palette.background.paper};
              border-color: ${theme.palette.divider};
              color: ${theme.palette.text.secondary};
            }
            .view-toggle .btn.active {
              background-color: ${theme.palette.primary.main};
              border-color: ${theme.palette.primary.main};
              color: ${theme.palette.primary.contrastText};
            }

            .group-card {
              cursor: pointer;
              transition:
                transform 0.3s ease,
                box-shadow 0.3s ease;
              background-color: ${theme.palette.background.paper} !important;
              border: 1px solid ${theme.palette.divider} !important;
            }
            .group-card:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            }
            .card-img-top {
              height: 220px;
              object-fit: cover;
              border-top-left-radius: 1rem;
              border-top-right-radius: 1rem;
            }
            .card-img-overlay {
              background: linear-gradient(
                to top,
                rgba(0, 0, 0, 0.8),
                transparent
              );
            }
            .privacy-badge {
              position: absolute;
              top: 1rem;
              right: 1rem;
              font-size: 12px;
              background: rgba(0, 0, 0, 0.6);
              backdrop-filter: blur(5px);
              text-transform: uppercase;
              padding: 0.25rem 0.75rem;
              border-radius: 50px;
              color: white;
            }
            .description-truncate {
              height: 40px;
              overflow: hidden;
              color: ${theme.palette.text.secondary} !important;
            }
            .members-count {
              color: ${theme.palette.text.primary} !important;
            }
            .join-button,
            .create-group-button {
              background: ${theme.palette.primary.main} !important;
              color: ${theme.palette.primary.contrastText} !important;
              border: none;
            }
            .join-button:disabled {
              background: ${theme.palette.action.disabledBackground} !important;
              color: ${theme.palette.text.disabled} !important;
            }

            .no-groups-img {
              width: 150px;
              opacity: 0.6;
              margin-bottom: 20px;
            }

            .skeleton-image,
            .skeleton-line,
            .skeleton-button {
              background: linear-gradient(
                90deg,
                ${theme.palette.background.default} 25%,
                ${theme.palette.divider} 50%,
                ${theme.palette.background.default} 75%
              );
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite;
              border-radius: 4px;
            }
            .skeleton-button {
              border-radius: 50px;
            }
            @keyframes shimmer {
              0% {
                background-position: -200% 0;
              }
              100% {
                background-position: 200% 0;
              }
            }
          `}</style>
        </Box>
      </Box>
    </Box>
  );
}

export default GroupsPage;
